export default "__VITE_ASSET__B5LO8gho__"